import i18next from "i18next";

import { put, takeEvery } from "redux-saga/effects";

import { AlertBean } from "../../../beans";

import {
  AlertsAction,
  AlertsActionEnum,
  IAlertsAddApiAlert,
  IAlertsRemoveApiAlert,
  alertsAdd,
  alertsRemove,
} from "./actions";

export function* addApiAlertSaga(action: IAlertsAddApiAlert) {
  yield put(
    alertsAdd({ message: i18next.t("newwotd.genericError"), id: "apiAlert" }),
  );
}
export function* removeApiAlertSaga(action: IAlertsRemoveApiAlert) {
  yield put(alertsRemove("apiAlert"));
}

export function* sagas() {
  yield takeEvery(AlertsActionEnum.ADD_API_ALERT, addApiAlertSaga);
  yield takeEvery(AlertsActionEnum.REMOVE_API_ALERT, removeApiAlertSaga);
}

export interface IAlertsState {
  alerts: AlertBean[];
}

const initialState: IAlertsState = {
  alerts: [],
};

const Alert = (
  state: IAlertsState = initialState,
  action: AlertsAction,
): IAlertsState => {
  switch (action.type) {
    case AlertsActionEnum.ADD:
      return {
        ...state,
        alerts: [...state.alerts.concat(action.alerts)],
      };
    case AlertsActionEnum.REMOVE:
      const alerts = state.alerts.slice();
      const index = alerts.findIndex((item) => item.id === action.id);
      if (index >= 0) alerts.splice(index, 1);
      return {
        ...state,
        alerts,
      };
    case AlertsActionEnum.RESET:
      return { ...state, alerts: [] };
    default:
      return state;
  }
};
export default Alert;
